// src/pages/DashboardPage.tsx
import React from "react";
import { Tabs } from "antd";
// import UserSetting from './UserSetting';
import { useTypedSelector } from "../../store";
import { Navigate } from "react-router-dom";
import Overtime from "./Overtime";
import Attendance from "./Attendance";
import Leave from "./Leave";
import ProfileUpdate from "./Profile";

const { TabPane } = Tabs;

const ApprovalPage: React.FC = () => {
  const { authData, isLogin } = useTypedSelector((state) => {
    return {
      authData: state.Auth.loginData,
      isLogin: state.Auth.isLogin,
    };
  });
  console.log(authData, isLogin);

  if (!isLogin) {
    return <Navigate to="/login" replace />;
  }
  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Attendance" key="1">
        <Attendance />
      </TabPane>
      <TabPane tab="Overtime" key="2">
        <Overtime />
      </TabPane>
      <TabPane tab="Leave" key="3">
        <Leave />
      </TabPane>
      <TabPane tab="Profile Update" key="4">
        <ProfileUpdate />
      </TabPane>
    </Tabs>
  );
};

export default ApprovalPage;
